import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m27.732 22.132.224-.968a1.716 1.716 0 0 0-.991-1.958l-5.932-2.543a1.71 1.71 0 0 0-1.995.49l-.928 1.128zM0 2.98C0 16.772 11.222 28 25.02 28a1.7 1.7 0 0 0 1.665-1.325l.513-2.224-10.57-4.354a19 19 0 0 1-8.726-8.772L3.548.802l-2.223.513A1.7 1.7 0 0 0 0 2.98m10.845 5.983a1.7 1.7 0 0 0 .49-1.994L8.795 1.034C8.466.274 7.634-.14 6.787.044l-.919.223 3.845 9.62z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "m27.195 24.45.535-2.32-9.576-3.85-1.482 1.814zM7.9 11.323l1.81-1.438L5.867.266 3.547.8z",
      opacity: ".3"
    }, null, -1)
  ])))
}
export default { render: render }